module.exports = __webpack_public_path__ + "img/1_1.ce524502.gif";